<template>
  <iframe
    id="mainiframe"
    :src="compileUrl"
    class="eqc-dialog-xdcost"
    frameborder="0"
    :width="width"
    :height="height"
    scrolling="no"></iframe>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    close: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      width: 800,
      height: 600
    }
  },
  computed: {
    compileUrl () {
      return `${this.data.url}`
    }
  },
  mounted () {
    window.addEventListener('message', this.onMessage)
  },
  destroyed () {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    onMessage (e) {
      const { data } = e
      try {
        if (data.msgType === 'success') {
          this.close(data)
        } else if (data.msgType === 'close') {
          this.close(data)
        } else if (data.msgType === 'resize') {
          // console.log(e.data)
        } else if (data.msgType === 'done') {
          this.$el.contentWindow.postMessage(this.data.data, '*')
        }
      } catch (err) {
        this.$message.error(err)
      }
    }
  }
}
</script>

<style lang="scss">
.eqc-dialog-xdcost {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
}
</style>
